import {useState} from 'react'
import WarehouseAccessForm from './WarehouseAccessForm';
import WarehouseAccessList from './WarehouseAccessList';

const WarehouseAccess = () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <WarehouseAccessForm addForm={setFromIsShown} update={upData} />
        ) : (
          <WarehouseAccessList addForm={setFromIsShown} update={setUpData} />
        )}
  
    </>
  )
}

export default WarehouseAccess